import { getCarriers } from '@/api'
import { CarrierResponse } from '@/types/carrier.type'
import { useQuery, UseQueryOptions } from 'react-query'

const keys = {
  carriers: 'carriers',
  carrier: 'carrier',
}

export const useCarriers = (options: UseQueryOptions<CarrierResponse>) =>
  useQuery<CarrierResponse>(keys.carriers, getCarriers, options)
